import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { campaignService } from '../services/campaignService';
import CampaignForm from '../components/campaign/CampaignForm';
import Loading from '../components/common/Loading';

const EditCampaign = () => {
  const { campaignId } = useParams();
  const [campaign, setCampaign] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const load = async () => {
      try {
        setCampaign(await campaignService.getCampaignById(campaignId));
      } catch (err) {
        setError(err.message || 'Failed to load campaign');
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [campaignId]);

  if (loading) return <Loading message="Loading campaign..." />;
  if (error) return <div className="error-message">{error}</div>;

  return (
    <CampaignForm
      mode="edit"
      campaign={campaign}
      onSubmit={(payload) => campaignService.updateCampaign(campaignId, payload)}
    />
  );
};

export default EditCampaign;
